module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v2layout",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "v2container client"
  }, [_c('clientb-header'), _c('div', {
    staticClass: "clientBMain"
  }, [_c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "Document"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 1), _c('clientb-footer'), _c('fast-entry')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbb0ed28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 410
// module chunks = 0